import React from "react";
import { NavLink } from "react-router-dom";
import Noise from "../background/noise";
import { Link } from "react-scroll";
const Header = props => {
  let header = React.createRef();

  let openMenu = e => {
    if (header.current.classList.contains("active")) {
      header.current.classList.remove("active");
    } else {
      header.current.classList.add("active");
    }
  };

  let closeMenu = () => {
    let w = window.innerWidth;
    if (w <= 992) {
      if (header.current.classList.contains("active")) {
        header.current.classList.remove("active");
      }
    }
  };
  let clickGetStarted = () => {
    if (header.current.classList.contains("active")) {
      header.current.classList.remove("active");
      setTimeout(() => {
        document.getElementById("present").click();
      }, 300);
    }
  };

  return (
    <header ref={header} onClick={props.ghost} className={props.activeClass}>
      <div className="wrapLogo">
        <Link spy={true} smooth={true} offset={0} duration={500} to="start_app">
          <svg
            className="logo"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 210 17"
            style={{ enableBackground: "new 0 0 210 17" }}
            xmlSpace="preserve"
          >
            <path
              className="st0"
              d="M210,16.7h-3.5V2.6l0.1-0.2c0,0-5.4,8.7-7.8,12.6c-1.7,2.8-4.5,2.8-6.2,0c-2.3-3.8-6.9-11.3-6.9-11.3L185,2.3v14.4h-3.5c0-0.1,0-0.3,0-0.4c0-3.4,0-9,0-11.1c0-0.5,0.3-1.1,0.7-1.5l3.3-3.2c0.4-0.4,1.4-0.7,1.8-0.4c0.4,0.3,0.9,1.1,1.3,1.6c2.1,3.4,3.9,6.6,6,10c0.4,0.6,0.7,1.2,1.2,2c0.3-0.5,0.5-0.8,0.7-1.1c2.3-3.7,4.1-7.1,6.4-10.8c1.3-2,4.9-2.3,6.3-0.6c0.5,0.6,0.9,1.5,0.9,2.3c0,3.2,0,6.4,0,9.6C210,14.3,210,15.5,210,16.7z M176.5,13.1l-3,2.9c-0.5,0.5-1.4,0.8-2.1,0.8c-2.5,0-8.3,0-11.6,0c-2.7,0-4.6-1.9-4.6-4.5c0-1.7,0-4.7,0-6.3c0-0.6,0.3-1.2,0.7-1.7l3.1-3c0.5-0.5,1.1-0.7,1.8-0.7c1.4,0,3.9,0,5.4,0c2.1,0,4.1,0,6.2,0c3,0,4.9,2,4.9,4.9c0,1.6,0,4.2-0.1,5.8C177.1,11.9,177,12.6,176.5,13.1z M173.8,13c0,0,0-5.9,0-9.2c-5.5,0-9.8,0-15,0c0,3.5,0,6.3,0,9.8c5.2,0,15,0,15,0V13z M150.9,13.1l-3,2.9c-0.6,0.5-1.4,0.8-2.1,0.8c-2.5,0-8.3,0-11.6,0c-2.7,0-4.6-1.9-4.6-4.5c0-1.7,0-4.7,0-6.3c0-0.6,0.3-1.2,0.7-1.7l3.1-3c0.5-0.5,1.1-0.7,1.8-0.7c1.4,0,3.9,0,5.4,0c2.1,0,4.1,0,6.2,0c3,0,4.9,2,4.9,4.9c0,1.6,0.1,4.2,0,5.8C151.6,11.9,151.4,12.6,150.9,13.1z M148.1,12.7c0,0,0-5.6,0-8.9c-5.5,0-9.7,0-15,0c0,3.5,0,6.3,0,9.8c5.2,0,15,0,15,0V12.7z M125.8,16.7l-0.1-0.1L125.8,16.7h-2.9h-1.2l-4.4-4.9c0.7,0.8-1.5-1.5,0,0l-2.9-3.2c0.4,0,3.9,0,4.4,0h3.5V3.7H109v7.2c0,0,0,1.2,0,1.2c0,1.6,0,3,0,4.6c-1,0-2.5-0.1-3.5,0c0-5.3,0-10.7,0-16.1c0.4,0,1.4,0,1.8,0c5.2,0,8.1,0.1,13.3,0c3.5,0,5.3,1.6,5.3,4.9c0,0.3,0,0.6,0,0.9c0,2.5-0.4,3-1.3,4.2c-0.8,1.1-3.4,1.2-3.4,1.2l2.9,3.1L125.8,16.7z M101.1,12.3c-0.1,2.5-1.7,4.3-4.3,4.4c-5.9,0.1-11.3,0-17.3,0c0-5.3,0-10.7,0-16.1c0.5,0,0.2,0,0.6,0c5.3,0,10.3,0,15.6,0c2,0,4,0.4,4.8,2.3c0.8,1.7,0.5,3.4,0,3.9c-0.4,0.6-2,1.8-2,1.8s1.5,1.5,2,1.8C101.2,11.3,101.1,11.9,101.1,12.3z M97.5,3.7c-5.6,0-9.3,0-14.7,0c0,1.3,0,2.3,0,3.5c5.6,0,9.2,0,14.7,0C97.5,6,97.5,5,97.5,3.7z M97.5,9.8H82.8v3.7h14.7V9.8z M79.5,16.7C79.7,16.8,79.5,16.7,79.5,16.7z M72.2,0.6c0.9,0,2.3,0,3.2,0c0,5.3,0,10.7,0,16.1c-1,0-2.3,0-3.2,0C72.2,11.4,72.2,6,72.2,0.6z M56,16.7c-0.6,0-1.2-0.2-1.6-0.6l-3-2.9C51.2,13,51,12.7,51,12.4V0.6h3.5v13H68v3.2h-1.2C63.8,16.7,58.3,16.7,56,16.7z M30.9,16.7c-3,0-5-2.4-5-4.3c0-2.7,0-5.3,0.1-8c0-2.1,1.7-3.5,3.8-3.8c0.4-0.1,0.7,0,1.1,0c5.2,0,9.8,0,14.9,0c0.4,0,0.9,0,1.3,0c-0.1,0,0,3.2,0,3.2H30.3h-0.9v3.2c0.6,0,3.2,0,3.8,0h13.8v3.2H29.5v3.5h17.7v3.2c-0.4,0-0.8,0-1.2,0C40.7,16.7,36.2,16.7,30.9,16.7z M17.3,16.7c-4.6,0-9.2,0-13.9,0v0c-1,0-2.1,0-3,0c-0.1,0-0.2,0-0.4-0.1C0,11.3,0,6,0,0.6c0.5,0,0.8,0,1.2,0c5.2,0,10.5,0,15.6,0c3.4,0,5,1.6,5,4.9c0,2.2,0,4.4,0,6.6C21.8,14.7,20,16.7,17.3,16.7z M18.6,4h-15v9.2c2,0,3.8,0,4.4,0h1.2c2.7,0,6.2,0,8.8,0c0.2,0,0.6-0.4,0.6-0.6C18.6,9.9,18.6,6.9,18.6,4z"
            />
          </svg>
        </Link>
        <NavLink to="/" onClick={closeMenu}>
          <svg
            className="logo"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 210 17"
            style={{ enableBackground: "new 0 0 210 17" }}
            xmlSpace="preserve"
          >
            <path
              className="st0"
              d="M210,16.7h-3.5V2.6l0.1-0.2c0,0-5.4,8.7-7.8,12.6c-1.7,2.8-4.5,2.8-6.2,0c-2.3-3.8-6.9-11.3-6.9-11.3L185,2.3v14.4h-3.5c0-0.1,0-0.3,0-0.4c0-3.4,0-9,0-11.1c0-0.5,0.3-1.1,0.7-1.5l3.3-3.2c0.4-0.4,1.4-0.7,1.8-0.4c0.4,0.3,0.9,1.1,1.3,1.6c2.1,3.4,3.9,6.6,6,10c0.4,0.6,0.7,1.2,1.2,2c0.3-0.5,0.5-0.8,0.7-1.1c2.3-3.7,4.1-7.1,6.4-10.8c1.3-2,4.9-2.3,6.3-0.6c0.5,0.6,0.9,1.5,0.9,2.3c0,3.2,0,6.4,0,9.6C210,14.3,210,15.5,210,16.7z M176.5,13.1l-3,2.9c-0.5,0.5-1.4,0.8-2.1,0.8c-2.5,0-8.3,0-11.6,0c-2.7,0-4.6-1.9-4.6-4.5c0-1.7,0-4.7,0-6.3c0-0.6,0.3-1.2,0.7-1.7l3.1-3c0.5-0.5,1.1-0.7,1.8-0.7c1.4,0,3.9,0,5.4,0c2.1,0,4.1,0,6.2,0c3,0,4.9,2,4.9,4.9c0,1.6,0,4.2-0.1,5.8C177.1,11.9,177,12.6,176.5,13.1z M173.8,13c0,0,0-5.9,0-9.2c-5.5,0-9.8,0-15,0c0,3.5,0,6.3,0,9.8c5.2,0,15,0,15,0V13z M150.9,13.1l-3,2.9c-0.6,0.5-1.4,0.8-2.1,0.8c-2.5,0-8.3,0-11.6,0c-2.7,0-4.6-1.9-4.6-4.5c0-1.7,0-4.7,0-6.3c0-0.6,0.3-1.2,0.7-1.7l3.1-3c0.5-0.5,1.1-0.7,1.8-0.7c1.4,0,3.9,0,5.4,0c2.1,0,4.1,0,6.2,0c3,0,4.9,2,4.9,4.9c0,1.6,0.1,4.2,0,5.8C151.6,11.9,151.4,12.6,150.9,13.1z M148.1,12.7c0,0,0-5.6,0-8.9c-5.5,0-9.7,0-15,0c0,3.5,0,6.3,0,9.8c5.2,0,15,0,15,0V12.7z M125.8,16.7l-0.1-0.1L125.8,16.7h-2.9h-1.2l-4.4-4.9c0.7,0.8-1.5-1.5,0,0l-2.9-3.2c0.4,0,3.9,0,4.4,0h3.5V3.7H109v7.2c0,0,0,1.2,0,1.2c0,1.6,0,3,0,4.6c-1,0-2.5-0.1-3.5,0c0-5.3,0-10.7,0-16.1c0.4,0,1.4,0,1.8,0c5.2,0,8.1,0.1,13.3,0c3.5,0,5.3,1.6,5.3,4.9c0,0.3,0,0.6,0,0.9c0,2.5-0.4,3-1.3,4.2c-0.8,1.1-3.4,1.2-3.4,1.2l2.9,3.1L125.8,16.7z M101.1,12.3c-0.1,2.5-1.7,4.3-4.3,4.4c-5.9,0.1-11.3,0-17.3,0c0-5.3,0-10.7,0-16.1c0.5,0,0.2,0,0.6,0c5.3,0,10.3,0,15.6,0c2,0,4,0.4,4.8,2.3c0.8,1.7,0.5,3.4,0,3.9c-0.4,0.6-2,1.8-2,1.8s1.5,1.5,2,1.8C101.2,11.3,101.1,11.9,101.1,12.3z M97.5,3.7c-5.6,0-9.3,0-14.7,0c0,1.3,0,2.3,0,3.5c5.6,0,9.2,0,14.7,0C97.5,6,97.5,5,97.5,3.7z M97.5,9.8H82.8v3.7h14.7V9.8z M79.5,16.7C79.7,16.8,79.5,16.7,79.5,16.7z M72.2,0.6c0.9,0,2.3,0,3.2,0c0,5.3,0,10.7,0,16.1c-1,0-2.3,0-3.2,0C72.2,11.4,72.2,6,72.2,0.6z M56,16.7c-0.6,0-1.2-0.2-1.6-0.6l-3-2.9C51.2,13,51,12.7,51,12.4V0.6h3.5v13H68v3.2h-1.2C63.8,16.7,58.3,16.7,56,16.7z M30.9,16.7c-3,0-5-2.4-5-4.3c0-2.7,0-5.3,0.1-8c0-2.1,1.7-3.5,3.8-3.8c0.4-0.1,0.7,0,1.1,0c5.2,0,9.8,0,14.9,0c0.4,0,0.9,0,1.3,0c-0.1,0,0,3.2,0,3.2H30.3h-0.9v3.2c0.6,0,3.2,0,3.8,0h13.8v3.2H29.5v3.5h17.7v3.2c-0.4,0-0.8,0-1.2,0C40.7,16.7,36.2,16.7,30.9,16.7z M17.3,16.7c-4.6,0-9.2,0-13.9,0v0c-1,0-2.1,0-3,0c-0.1,0-0.2,0-0.4-0.1C0,11.3,0,6,0,0.6c0.5,0,0.8,0,1.2,0c5.2,0,10.5,0,15.6,0c3.4,0,5,1.6,5,4.9c0,2.2,0,4.4,0,6.6C21.8,14.7,20,16.7,17.3,16.7z M18.6,4h-15v9.2c2,0,3.8,0,4.4,0h1.2c2.7,0,6.2,0,8.8,0c0.2,0,0.6-0.4,0.6-0.6C18.6,9.9,18.6,6.9,18.6,4z"
            />
          </svg>
        </NavLink>
      </div>

      <div className="wrapper">
        <nav>
          <div className="menu_links">
           
            <NavLink to="/#pricing" className="to_pricing" onClick={closeMenu}>
              Pricing
            </NavLink>
            <NavLink to="/help-center" onClick={closeMenu}>
              Help center
            </NavLink>
            <NavLink to="/contact" onClick={closeMenu}>
              Contact
            </NavLink> 
            {props.showLink ? (
              <NavLink
                to="/user-emails"
                target="_blank"
                onClick={props.removeLink}
              >
                {" "}
                User emails
              </NavLink>
            ) : (
              ""
            )}

            <div className="mobile_section socials">
              <a
                href={props.links.socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
              <a
                href={props.links.socialLinks.twitter}
                target="_blank"
                rel="noopener noreferrer"
              >
                Twitter
              </a>
              <a
                href={props.links.socialLinks.linkedin}
                target="_blank"
                rel="noopener noreferrer"
              >
                Linkedin
              </a>
            </div>
          </div>

          <div className="mobile_section envelope">
            <p className="help">Need help?</p>
            <a
              href={`mailto:${props.links.support}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="18px"
              >
                <path
                  fillRule="evenodd"
                  fill="rgb(255, 255, 255)"
                  d="M21.000,0.000 L2.999,0.000 C1.343,0.000 -0.001,1.343 -0.001,3.000 L-0.001,15.000 C-0.001,16.657 1.343,18.000 2.999,18.000 L21.000,18.000 C22.657,18.000 24.001,16.657 24.001,15.000 L24.001,3.000 C24.001,1.343 22.657,0.000 21.000,0.000 ZM16.000,8.000 L22.999,2.000 C23.045,2.141 22.999,2.845 22.999,3.000 L22.999,15.000 C22.999,15.104 22.460,15.196 22.440,15.294 L16.000,8.000 ZM21.000,1.000 C21.099,1.000 21.906,0.981 22.000,1.000 L12.000,10.000 L1.999,1.000 C2.093,0.981 2.900,1.000 2.999,1.000 L21.000,1.000 ZM1.559,15.293 C1.538,15.195 0.999,15.104 0.999,15.000 L0.999,3.000 C0.999,2.845 0.955,2.141 0.999,2.000 L8.000,8.000 L1.559,15.293 ZM2.999,17.000 C2.848,17.000 2.138,16.042 1.999,16.000 L9.000,9.000 L12.000,11.000 C12.139,11.121 11.826,11.250 12.000,11.250 C12.173,11.250 12.348,11.190 12.488,11.068 L15.000,9.000 L22.000,16.000 C21.862,16.042 21.152,17.000 21.000,17.000 L2.999,17.000 Z"
                />
              </svg>
              {props.links.support}
            </a>
          </div>
        </nav>
        <div
          className="mobile_section wrap_get_started"
          onClick={clickGetStarted}
        >
          <Noise />
          <span>Obtain control of office scheduling</span>
          <div className="get_started_button">
            Get started
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="92.5px"
              height="35.5px"
            >
              <path
                fillRule="evenodd"
                stroke="rgb(255, 255, 255)"
                strokeWidth="1px"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                fill="none"
                d="M74.570,34.500 L71.586,31.504 L83.395,19.625 L0.500,19.625 L0.500,15.375 L83.395,15.375 L71.586,3.496 L74.570,0.500 L91.500,17.500 L74.570,34.500 Z"
              />
            </svg>
          </div>
        </div>
      </div>
      <button
        className="btn clear present"
        onClick={props.openModal}
        id="present"
      >
        <span>Get started</span>
      </button>
      <div className="mobile_button" onClick={openMenu}>
        <span />
        <span />
        <span />
        <em className="title">Close</em>
      </div>
    </header>
  );
};

export default Header;
